import axios from 'axios'

const getHeaders = () => {
  return {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      'Content-Type': 'application/json',
    },
  }
}

const handleRequest = async (request) => {
  try {
    const response = await request()
    return response.data
  } catch (error) {
    console.error('API request failed:', error)
    throw error
  }
}

export const getAllPlans = async () => {
  const response = await axios.get(
    `${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/plans`,
    getHeaders()
  )
  return response.data
}

export const getAllSubsGroups = async () => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/groups`, getHeaders())
  )
}

export const getSubsModules = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/group/${id}`,
      getHeaders()
    )
  )
}

export const getSubsModuleLabs = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/module/${id}`,
      getHeaders()
    )
  )
}

export const getSubsLabDetails = async (id) => {
  return handleRequest(() =>
    axios.get(`${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/lab/${id}`, getHeaders())
  )
}

export const getUserAccessInfo = async () => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v2/subscription/enrollment/access-info`,
      getHeaders()
    )
  )
}

export const getSubscribedSpecificLabCount = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${
        import.meta.env.VITE_LABINFO_API_URL
      }/api/v1/labInfo/subscription/lab/user/get_counter/${id}`,
      getHeaders()
    )
  )
}

export const addSubscriptionSpecificLabCount = async (id) => {
  return handleRequest(() =>
    axios.get(
      `${import.meta.env.VITE_LABINFO_API_URL}/api/v1/labInfo/subscription/lab/counter/${id}`,
      getHeaders()
    )
  )
}

export const resetSubscriptionLoadBalancerCounter = async (userId, labId) => {
  const payload = {
    lb_counter: 0,
  }
  const response = await axios.put(
    `${
      import.meta.env.VITE_LABINFO_API_URL
    }/api/v1/labInfo/subscription/lab/user/update/${userId}/${labId}`,
    payload,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  )
  return response
}
